import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

function Video() {

    return (

        <>
            <>
                <Header />

                {/* Page Header Section Start */}
                <div className="page-header bg-section parallaxie">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* Page Header Box Start */}
                                <div className="page-header-box">
                                    <h1 className="text-anime-style-3" data-cursor="-opaque">
                                        Our video
                                    </h1>
                               
                                </div>
                                {/* Page Header Box End */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Page Header Section End */}
                {/* Page Video Gallery Start */}
                <div className="page-video-gallery">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-6">
                                {/* Video Gallery start */}
                                <div className="video-gallery-image wow fadeInUp">
                                    <a
                                        href="https://www.youtube.com/watch?v=ZW3QuHpLZSU"
                                        className="popup-video"
                                        data-cursor-text="Play"
                                    >
                                        <figure>
                                            <img src="images/tirthakhetra.jpg" alt="" />
                                        </figure>
                                    </a>
                                </div>
                                {/* Video Gallery end */}
                            </div>
                          
                     
                        </div>
                    </div>
                </div>
                {/* Page Video Gallery End */}

                <Footer />
            </>

        </>
    );
}

export default Video;